import React, { FC, useEffect, useState } from 'react';
import { openGraph } from '@/client/utils/staticOpenGraph';

export interface ShareHeadProps {
  shareTitle: string;
  description: string;
  shareImg: string;
  siteUrl?: string;
}

const {
  siteName,
  ogType,
  twitterCardType,
  useAppLink,
  fbAppId,
  indexScheme,
  packageName,
  packageUrl,
  appId,
  appName,
  androidAppForGoogle,
  iosAppForGoogle,
} = openGraph;

const ShareHead: FC<ShareHeadProps> = ({ shareTitle, description, shareImg, siteUrl }) => {
  const [url, setUrl] = useState<string | undefined>(siteUrl);

  useEffect(() => {
    !url && setUrl(location.href);
  }, []);

  const appMeta = useAppLink && (
    <>
      <link rel="alternate" href={androidAppForGoogle} />
      <link rel="alternate" href={iosAppForGoogle} />
      <meta property="fb:app_id" content={fbAppId} />
      <meta property="al:ios:url" content={indexScheme} />
      <meta property="al:ios:app_name" content={appName} />
      <meta property="al:ios:app_store_id" content={appId} />
      <meta property="al:android:package" content={packageName} />
      <meta property="al:android:app_name" content={appName} />
      <meta property="al:android:url" content={indexScheme} />
      <meta property="al:web:should_fallback" content="false" />
      <meta name="twitter:app:name:iphone" content={appName} />
      <meta name="twitter:app:id:iphone" content={appId} />
      <meta name="twitter:app:url:iphone" content={indexScheme} />
      <meta name="twitter:app:name:ipad" content={appName} />
      <meta name="twitter:app:id:ipad" content={appId} />
      <meta name="twitter:app:url:ipad" content={indexScheme} />
      <meta name="twitter:app:name:googleplay" content={appName} />
      <meta name="twitter:app:id:googleplay" content={packageName} />
      <meta name="twitter:app:url:googleplay" content={packageUrl} />
    </>
  );

  return (
    <>
      {/* facebook和whatsApp的分享用这些就可以了 */}
      <meta property="og:title" content={shareTitle} />
      <meta property="og:site_name" content="SnackVideo"></meta>
      <meta property="og:url" content={url} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={shareImg} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:type" content={ogType} />

      {/* twitter有自己独特的分享头，但是也依赖上面的og系列 */}
      <meta name="twitter:card" content={twitterCardType} />
      <meta name="twitter:site" content={siteName} />
      <meta name="twitter:title" content={shareTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={shareImg} />
      <meta name="twitter:url" content={url} />

      {/* AppLink 当有app的时候点进去可以直接进入app的某个页面，当没有的时候跳往app下载 */}
      {appMeta}
    </>
  );
};

export default ShareHead;
